import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { Appointment, Car, Pin, Snooze } from "models";

const component = "CarDetails";

// TODO: most of these are actually paginated but we only extract .items in the queryFn
export const CarDetailsQueryKeys = {
  appointmentHistory: (car_id?: number) =>
    backendQueryKey<Appointment[]>({ component, baseUrl: ENV.carBaseURL, endpoint: "/appointments/history/list", params: { car_id } }),
  holdingAppointmentHistory: (car_id?: number) =>
    backendQueryKey<Appointment[]>({ component, baseUrl: ENV.holdingBaseURL, endpoint: "/appointments/history/list", params: { car_id } }),
  details: backendQueryKey<Car>({ component, baseUrl: ENV.carBaseURL, endpoint: "/cars/details" }),
  pinItems: backendQueryKey<Pin[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/pins/list_by_car_id" }),
  snoozeItems: backendQueryKey<Snooze[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/snoozes/list_by_car_id" }),
  customerInfo: (id: number) =>
    backendQueryKey<Appointment>({
      component,
      baseUrl: ENV.appointmentBaseURL,
      endpoint: "/appointments/view",
      params: { embed: "customer_owner,customer_driver,customer_contract", id }
    })
};
